import React, { ReactNode } from 'react';
import { styles } from './styles';

interface DynamicScrollerProps {
  children?: ReactNode;
}

const DynamicScroller = ({ children }: DynamicScrollerProps): JSX.Element => {
  const classes = styles();
  return (
    <div className={classes.scroller}>
      <div>{children}</div>
    </div>
  );
};

export default DynamicScroller;
